import React from 'react';
import { observer } from 'mobx-react-lite';
import { SxProp } from 'dripsy';

import {
  EmptyResultTypeEnum,
  MessageList as BaseMessageList,
} from '@components';
import type { MessageList } from '@models/Chats/MessageListModel';

const contentContainerStyle: SxProp = {
  flexGrow: 1,
  px: ['$6', '$0'],
  bg: '$background0',
};

interface IMessagesListProps {
  list: MessageList;
  fetchMore(): Promise<void>;
}

export const MessagesList = observer<IMessagesListProps>(
  ({ list, fetchMore }) => {
    const isLoading = list.fetch.inProgress && list.isEmpty;

    let emptyResultType: EmptyResultTypeEnum =
      EmptyResultTypeEnum.Error;

    if (list.fetch.isError) {
      emptyResultType = EmptyResultTypeEnum.Error;
    } else if (list.isEmpty) {
      emptyResultType = EmptyResultTypeEnum.NoMessages;
    }

    return (
      <BaseMessageList
        contentContainerSx={contentContainerStyle}
        data={list.asArray}
        onEndReached={fetchMore}
        isRefreshing={list?.fetch.inProgress}
        isLoading={isLoading}
        isLoadingMore={list?.fetchMore.inProgress}
        emptyResultType={emptyResultType}
      />
    );
  },
);
